<template>
  <div class="carousel-container">
    <div class="carousel"
         :class="{ 'flex justify-end': justifyEnd }"
         ref="carousel"
         @scroll="handleScroll(false)"
    >
      <div v-for="(card, i) in payload"
           :key="i"
           class="carousel-card"
      >
        <div class="carousel-card-detail">
          <img :src="card.image_url"/>
          <p v-if="card.title" class="carousel-card-title">{{card.title}}</p>
          <p v-if="card.text" class="carousel-card-content">{{card.text}}</p>
        </div>

        <div v-if="card.buttons" class="carousel-card-buttons">
          <a v-for="(button, idx) in card.buttons"
             :key="idx"
             :href="button.type === 'phone' ? `tel:${button.payload}` : button.payload"
             target="_blank"
             class="button hover:cursor-pointer text-gray-bubble hover:bg-gray-bubble hover:text-white"
          >
            <span>{{button.title}}</span>
          </a>
        </div>
      </div>
    </div>

    <div v-if="showLeftArrow"
         class="carousel-arrow-container"
         @click="scrollLeft"
    >
      <button class="carousel-arrow">
        <vs-icon icon="arrow_back" size="1rem"/>
      </button>
    </div>

    <div v-if="showRightArrow"
         class="carousel-arrow-container right-0"
         @click="scrollRight"
    >
      <button class="carousel-arrow">
        <vs-icon icon="arrow_forward right-0" size="1rem"/>
      </button>
    </div>

  </div>
</template>

<script>

export default {
  name: 'CarouselPreview',
  props: {
    payload: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      showLeftArrow: false,
      showRightArrow: false,
      justifyEnd: false
    }
  },
  methods: {
    handleScroll(calledFromMounted) {
      const carousel = this.$refs.carousel
      this.showLeftArrow = carousel.scrollLeft > 0
      this.showRightArrow = carousel.scrollLeft < (carousel.scrollWidth - carousel.clientWidth - 1)

      if (calledFromMounted && !this.showRightArrow) {
        this.justifyEnd = true
      }
    },
    scrollLeft() {
      const carousel = this.$refs.carousel
      carousel.scrollBy({ left: -160, behavior: 'smooth' })
    },
    scrollRight() {
      const carousel = this.$refs.carousel
      carousel.scrollBy({ left: 160, behavior: 'smooth' })
    }
  },
  mounted() {
    this.handleScroll(true) // Initial check to set arrow visibility
  }
}
</script>

<style lang="scss" scoped>
.carousel-container {
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  width: 100%;
  height: 100%;
  scrollbar-width: none;
  flex-direction: column;
  position: relative;
}

.carousel-arrow-container {
  margin: 8px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.carousel-arrow {
  border: none;
  background: rgb(234, 234, 234);
  box-shadow: 0 0 10px 6px white;
  height: 30px;
  width: 30px;
  border-radius: 50px;

  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.carousel-arrow:hover {
  box-shadow: 0 0 10px 5px rgba(200, 200, 200, 0.8);
}

.carousel {
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  height: 100%;
  scrollbar-width: none;
  align-items: stretch;
  flex-direction: row;
  position: relative;
  gap: 16px;

  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */
  scrollbar-width: none; /* Hide scrollbar for Firefox */
  -ms-overflow-style: none; /* Hide scrollbar for Internet Explorer and Edge */

  /* Hide scrollbar for WebKit browsers (Chrome, Safari) */
  &::-webkit-scrollbar {
    display: none; /* Hide scrollbar */
  }
}

.carousel-card {
  flex: 0 0 auto;
  width: 200px;
  border-radius: 10px;
  border: rgb(234, 234, 234) solid 1px;
  overflow: hidden;
  background-color: #fff;
  transition: transform 0.3s ease;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.carousel-card-detail {
  img {
    width: 100%;
    height: 150px;
    object-fit: cover;
  }
}
.carousel-card-title {
  font-weight: 700;
  font-size: 14px;
  margin: 10px 0 0 0;
  padding: 0 20px;
}
.carousel-card-content {
  margin: 5px 0 0 0;
  padding: 0 20px;
  font-size: 14px;
  font-weight: 300;
}

.carousel-card-buttons {
  display: flex;
  flex-direction: column;
  border-top: rgb(234, 234, 234) solid 1px;
  margin-top: 10px;

  > .button {
    border-bottom: rgb(234, 234, 234) solid 1px;
  }

  > .button:last-child {
    border-bottom: none;
  }
}
.button {
  border: none;
  width: 100%;
  margin: 0;
  font-size: 12px;
  font-family: inherit;
  text-decoration: none;
  text-align: center;
  display: inline-block;
  min-height: 40px;
  min-width: 90px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
a {
  text-decoration: none;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 30px;
  text-align: center;
}
</style>
